module.exports = __webpack_public_path__ + "img/ico_insurance_on.770c4213.svg";